<template>
        <span>{{ valueWithUnit }}</span>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';

const props = defineProps(['params']);

const valueWithUnit = ref('');

onBeforeMount(() => {
if (typeof props.params.value != 'undefined' && !Number.isNaN(parseInt(props.params.value)))
    valueWithUnit.value = formatSize(props.params.value);
else
    valueWithUnit.value = props.params.value;
})
function formatSize(value) {
    var size = 0;
    var unit = 'Ko';

    if (value)
        size = (props.params.value / 1024).toFixed(2);

    if (size > 1024) {
        size = (size / 1024).toFixed(2);
        unit = 'Mo';
    }

    return size + ' ' + unit;
}


</script>
